/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import BaseControl from './BaseControl.vue';

/**
 * Base component to wrap checkboxes with a common markup.
 *
 * It has all `BaseControl` options, plus:
 *
 * @vue-prop {String} [topLabel=null] an optional label to be used as a control group label
 *
 * @example
 *
 * checkbox(:label="t('test_event')" v-model="form.test_event" name="test_event")
 *
 * @category ui.components.form-elements
 * @exports Checkbox
 * @component
 */
const __vue_script__ = {
    name: 'Checkbox',

    extends: BaseControl,

    props: {
        topLabel: {
            type: String,
            default: null
        },

        value: {
            type: Boolean,
            default: false
        },

        itemised: {
            type: Boolean,
            default: false
        },

        inverted: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            controlLabel: this.label
        };
    },

    methods: {
        /**
         * Triggered when user interacts with selects component.
         *
         * @param {InputEvent} $event
         */
        change($event) {
            const val = this.inverted ? !$event.target.checked : $event.target.checked;
            this.$emit('input', val);
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "control-decorator",
    {
      attrs: {
        label: _vm.topLabel,
        tip: _vm.tip,
        hint: _vm.hint,
        uid: _vm.uid,
        errors: _vm.errors,
        "hint-after-label": _vm.hintAfterLabel,
        warning: _vm.warning,
        dependant: _vm.dependant,
      },
      scopedSlots: _vm._u(
        [
          _vm.$scopedSlots["hint"]
            ? {
                key: "hint",
                fn: function (ref) {
                  return [_vm._t("hint")]
                },
              }
            : null,
        ],
        null,
        true
      ),
    },
    [
      _c(
        "label",
        {
          staticClass: "checkbox",
          class: {
            "has-error": _vm.errors.length,
            "has-warning": _vm.warning,
            itemised: _vm.itemised,
            selected: _vm.itemised && _vm.value,
            disabled: _vm.disabled,
          },
        },
        [
          _c("input", {
            ref: "input",
            staticClass: "form-control",
            attrs: {
              id: _vm.uid,
              type: "checkbox",
              name: _vm.name,
              disabled: _vm.disabled,
            },
            domProps: { checked: _vm.inverted ? !_vm.value : _vm.value },
            on: { change: _vm.change },
          }),
          _c("span", {
            staticClass: "text",
            domProps: { innerHTML: _vm._s(_vm.controlLabel) },
          }),
        ]
      ),
    ]
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/form-components/Checkbox.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__